export function storeFilters(key, filters) {
  const finalKey = `filters-${key}`;
  sessionStorage.setItem(finalKey, JSON.stringify(filters));
}

export function restoreFilters(key) {
  const finalKey = `filters-${key}`;
  return JSON.parse(sessionStorage.getItem(finalKey));
}